module.exports = __webpack_public_path__ + "static/media/DPD.628d1ff0.svg";